module.exports = __webpack_public_path__ + "assets/img/TMSP2-3.f5cd83c4.jpg";